import { create } from "zustand";
import api from "../api/axios";
import getCurrentEnv from "../utils/getCurrentEnv";
import { getBaseUrl } from "../utils/getBaseUrl";
import { persist, createJSONStorage } from "zustand/middleware";

const useReportStore = create(
  persist(
    (set, get) => ({
      report: null,
      accessToken: null,
      tokenExpiry: null,
      reportName: "",
      lastSelectedPages: {}, // { [reportId]: pageName }
      isSwitchReport: false,
      tokenError: null,

      setReport: (newReport) => {
        set({ reportName: `${newReport.name}`, report: newReport });
        get().fetchAccessToken(newReport);
      },

      setIsSwitchReport: (value) => {
        set({ isSwitchReport: value });
      },

      setLastSelectedPage: (reportId, pageName) => {
        set((state) => ({
          lastSelectedPages: {
            ...state.lastSelectedPages,
            [reportId]: pageName,
          },
        }));
      },

      getLastSelectedPage: (reportId) => {
        return get().lastSelectedPages[reportId] || null;
      },

      resetLastSelectedPage: () =>
        set({ lastSelectedPages: {}, isSwitchReport: false }),

      resetReport: () =>
        set({ report: null, accessToken: null, tokenError: null }),

      fetchAccessToken: async (newReport) => {
        try {
          const response = await getAccessToken(newReport);
          if (response?.data?.Code === "InvalidRequest") {
            set({
              report: null,
              accessToken: null,
              tokenError:
                "Unable to complete your request at the moment. Please try again or return to the home page.",
            });
            return;
          }
          const { token, expiration } = response.data;

          set({
            accessToken: token,
            tokenExpiry: expiration,
            tokenError: null,
          });
        } catch (err) {
          console.log("Error in generating powerbi token: ", err);
          const errorMessage =
            "Unable to complete your request at the moment. Please try again or return to the home page.";
          set({
            report: null,
            accessToken: null,
            tokenError: errorMessage,
          });
        }
      },

      refreshAccessToken: async (powerBiEmbedded) => {
        if (powerBiEmbedded && powerBiEmbedded.current) {
          try {
            const response = await getAccessToken(get().report);

            if (response?.data?.Code === "InvalidRequest") {
              set({
                report: null,
                accessToken: null,
                tokenError:
                  "Unable to complete your request at the moment. Please try again or return to the home page.",
              });
              return;
            }

            const { token, expiration } = response.data;
            set({ tokenExpiry: expiration, tokenError: null });
            // Update the token via powerBiEmbedded to prevent reload
            powerBiEmbedded.current.setAccessToken(token);
          } catch (err) {
            console.log("Error in generating refresh token: ", err);
            const errorMessage =
              "Unable to complete your request at the moment. Please try again or return to the home page.";
            set({ tokenError: errorMessage });
          }
        }
      },
    }),
    {
      name: "report-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
const getAccessToken = (report) => {
  const env = getCurrentEnv();
  const trimmedGroupCode = report.customerGroupCode.trim();
  const trimmedReportName = report.name.trim();

  return api.post(`${getBaseUrl(env)}/generateToken`, {
    reportId: report.id,
    datasetId: report.datasetId,
    groupCode: trimmedGroupCode,
    reportName: trimmedReportName,
  });
};

export default useReportStore;
